export default __webpack_public_path__ + "static/media/Data-Aanalyst.e61c32cf.jpeg";